import { LoadingIndicator } from '@spotify-internal/encore-web';
import { css } from 'emotion';
import React from 'react';
import { Button, ButtonProps } from '../Button/NewButton';

export type LoadingButtonProps = {
  isLoading?: boolean;
} & ButtonProps;

/**
 * @deprecated If you are migrating a pages to encore use the LoadingButton in
 * @spotify-internal/anchor-ds it uses the encore button
 */
export const LoadingButton = ({
  isDisabled,
  isLoading,
  color,
  children,
  ...rest
}: LoadingButtonProps) => {
  return (
    <Button color={color} isDisabled={isDisabled || isLoading} {...rest}>
      {isLoading ? (
        <LoadingIndicator
          indicatorSize={LoadingIndicator.sm}
          className={
            color === 'red'
              ? css`
                  circle {
                    fill: white !important;
                  }
`
              : ''
          }
        />
      ) : (
        children
      )}
    </Button>
  );
};

LoadingButton.defaultProps = {
  kind: 'button',
};
